// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9855471f","453":"28e200e0","455":"1747fe95","977":"6a8fb3ad"}[chunkId] + ".chunk.js";
};